module.exports = __webpack_public_path__ + "img/3.71318e0d.jpeg";